import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { AppLoadingService } from '@examdojo/app-state';
import { CHALLENGE_DIALOG_LOADER_ID } from './challenge-resolver.model';

export const challengeResolver: ResolveFn<void> = () => {
  const appLoadingService = inject(AppLoadingService);

  appLoadingService.setLoadingOnce({ id: CHALLENGE_DIALOG_LOADER_ID });
};
